import { render, staticRenderFns } from "./AntistopList.vue?vue&type=template&id=50fd759b&scoped=true&"
import script from "./AntistopList.vue?vue&type=script&lang=js&"
export * from "./AntistopList.vue?vue&type=script&lang=js&"
import style0 from "./AntistopList.vue?vue&type=style&index=0&id=50fd759b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd759b",
  null
  
)

export default component.exports